"use client";

import { Dialog, DialogContent, DialogDescription, DialogTitle, DialogTrigger } from "@/components/ui/dialog";
import { VisuallyHidden } from "@radix-ui/react-visually-hidden";
import { CustomButton } from "@/components/ui/custom-button";
import { useParams } from "next/navigation";
import { get__video_for_locale } from "@/constants/videos";
import { CloudflareStreamVideo } from "@/components/shared/CloudflareStreamVideo";

interface DemoModalProps {
	type?: "xl" | "lg" | "sm" | "custom";
}

export function DemoModal({ type = "sm" }: DemoModalProps) {
	const params = useParams();
	const locale = (params?.locale as string) || "en-gb";
	const student_explainer_uid = get__video_for_locale(locale, "STUDENT_EXPLAINER_VIDEOS");

	return (
		<div className="">
			<Dialog>
				<DialogTrigger asChild>
					{type === "xl" ?
						<CustomButton variant="outline" size="lg" aria-label="Demo: Watch product demonstration">
							Demo
						</CustomButton>
						: type === "custom" ?
							<CustomButton variant="outline" size="lg" aria-label="Watch Demo: Watch product demonstration">
								Watch Demo
							</CustomButton>
							: <CustomButton
								variant="outline"
								size={type}
								aria-label="Demo: Watch product demonstration"
							>
								Demo
							</CustomButton>
					}
				</DialogTrigger>

				<DialogContent className="h-fit h-[50%] sm:h-[40%] md:h-[65%] lg:h-[80%] min-w-[70%]" aria-label="Product demonstration video" aria-keyshortcuts="Escape">
					<VisuallyHidden>
						<DialogTitle>
							StudyStash Product Demonstration
						</DialogTitle>
						<DialogDescription>
							Watch a product demonstration of StudyStash
						</DialogDescription>
					</VisuallyHidden>

					<CloudflareStreamVideo uid={student_explainer_uid} />
				</DialogContent>
			</Dialog>
		</div>
	);
}
